import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/intakeSent-actions';
import { IntakeSentActions } from '../constants';
import { IIntakeMedicalRelease } from 'src/types/intake-medical-release';

export interface IntakeMedicalReleaseState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IIntakeMedicalRelease>;
    current: IIntakeMedicalRelease | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],

        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function intakeMedicalReleases(
    state: IntakeMedicalReleaseState = initialState,
    action: Actions | any,
): IntakeMedicalReleaseState {
    switch (action.type) {
        case requestType(IntakeSentActions.PERSIST_MEDICAL_RELEASE):
            return { ...state, error: '', inProgress: true };
        case successType(IntakeSentActions.PERSIST_MEDICAL_RELEASE):
            return { ...state, current: action.payload, inProgress: false };
        case failureType(IntakeSentActions.PERSIST_MEDICAL_RELEASE):
            return { ...state, error: action.error, inProgress: false };
        default:
            return state;
    }
}
